import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ApiHandlerService } from '../api-handler.service';

@Component({
  selector: 'app-schedule-demo',
  templateUrl: './schedule-demo.component.html',
  styleUrls: ['./schedule-demo.component.css']
})
export class ScheduleDemoComponent implements OnInit {
  private apiUrl = `${environment.apiUrl}/schedule-demo`;
  showValidations = false;
  email = "";
  name = "";
  title = null;

  constructor(private router: Router,private apihandlerService:ApiHandlerService) { }

  ngOnInit() {
  }
  schedule() {
    if (this.email && this.name) {
      this.showValidations = false;
      this.apihandlerService.post(this.apiUrl,{email:this.email,name:this.name, title:this.title}).subscribe(()=>{
        window.open("https://calendly.com/omnidemo", '_blank');
        this.resetInputs();
      });

    } else {
      this.showValidations = true;
    }
  }
  resetInputs() {
    this.email = "";
    this.name = "";
    this.title = null;
  }
}
